/* ==========================================================================
   SERPROMAQ - MÓDULO INTERACTIVO DE CONTACTO Y ATENCIÓN DIRECTA
   ========================================================================== */

export function initContactModule() {
  const contactForm = document.getElementById('contactForm');
  const serviceChips = document.querySelectorAll('.contact-service-chip');
  const serviceInput = document.getElementById('contactService');
  const btnWhatsAppDirect = document.getElementById('btnContactWhatsAppDirect');

  // 1. Selector interactivo de chips de servicio
  if (serviceChips.length > 0 && serviceInput) {
    serviceChips.forEach(chip => {
      chip.addEventListener('click', () => {
        serviceChips.forEach(c => c.classList.remove('active'));
        chip.classList.add('active');
        const selectedValue = chip.getAttribute('data-service');
        if (selectedValue) {
          serviceInput.value = selectedValue;
        }
      });
    });
  }

  // 2. Botón directo de WhatsApp con datos del formulario
  if (btnWhatsAppDirect) {
    btnWhatsAppDirect.addEventListener('click', (e) => {
      e.preventDefault();

      const name = document.getElementById('contactName')?.value.trim() || 'Cliente Interesado';
      const phone = document.getElementById('contactPhone')?.value.trim() || 'No especificado';
      const company = document.getElementById('contactCompany')?.value.trim() || 'Particular';
      const rawService = serviceInput?.value || 'venta';
      
      const serviceLabels = {
        'venta': 'Venta de Maquinaria / Montacargas',
        'alquiler': 'Alquiler de Flota de Montacargas',
        'mantenimiento': 'Mantenimiento Preventivo / Correctivo',
        'repuestos': 'Repuestos, Llantas y Accesorios'
      };

      const service = serviceLabels[rawService] || 'Consulta General de Maquinaria';
      const message = document.getElementById('contactMessage')?.value.trim() || 'Deseo solicitar asesoría técnica y cotización.';

      const waText = `👋 *¡Hola SERPROMAQ! Deseo información comercial y técnica.*%0A%0A` +
        `👤 *Nombre:* ${encodeURIComponent(name)}%0A` +
        `📞 *Teléfono:* ${encodeURIComponent(phone)}%0A` +
        `🏢 *Empresa:* ${encodeURIComponent(company)}%0A` +
        `🚜 *Requerimiento:* ${encodeURIComponent(service)}%0A` +
        `📝 *Detalle:* ${encodeURIComponent(message)}%0A%0A` +
        `_Quedo atento a su pronta respuesta._`;

      window.open(`https://wa.me/573168275829?text=${waText}`, '_blank');
    });
  }

  // 3. Envío del formulario de contacto Web
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = contactForm.querySelector('button[type="submit"]');
      const originalText = submitBtn.innerHTML;

      const name = document.getElementById('contactName')?.value.trim();
      const phone = document.getElementById('contactPhone')?.value.trim();
      const company = document.getElementById('contactCompany')?.value.trim();
      const email = document.getElementById('contactEmail')?.value.trim();
      const service = serviceInput ? serviceInput.value : 'venta';
      const message = document.getElementById('contactMessage')?.value.trim();

      submitBtn.disabled = true;
      submitBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Procesando consulta...';

      // Enviar solicitud con FormData
      const formData = new FormData();
      formData.append('type', 'contacto');
      formData.append('name', name);
      formData.append('phone', phone);
      formData.append('email', email || '');
      formData.append('role', `Consulta Comercial: ${service.toUpperCase()}`);
      formData.append('experience', company ? `Empresa: ${company}` : 'Particular');
      formData.append('brands', `Email: ${email} | Mensaje: ${message || 'Sin mensaje adicional'}`);

      const endpointUrl = window.location.hostname.includes('serpromaqsas.com')
        ? '/send_application.php'
        : 'https://serpromaqsas.com/send_application.php';

      fetch(endpointUrl, {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        submitBtn.innerHTML = '<i class="fa-solid fa-check"></i> ¡Consulta Enviada!';
        submitBtn.style.background = '#10B981';

        setTimeout(() => {
          alert(`¡Gracias por contactar a SERPROMAQ S.A.S.!\n\nHemos recibido tu solicitud (${name}). Un asesor comercial se comunicará contigo vía WhatsApp o llamada en menos de 15 minutos.\n\nTambién puedes escribirnos de inmediato por nuestro chat de WhatsApp.`);
          contactForm.reset();
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          submitBtn.style.background = '';
        }, 300);
      })
      .catch(err => {
        console.warn('Envío web:', err);
        submitBtn.innerHTML = '<i class="fa-solid fa-check"></i> ¡Mensaje Procesado!';
        submitBtn.style.background = '#10B981';

        setTimeout(() => {
          alert(`¡Gracias ${name}!\n\nTu consulta ha sido registrada. Para atención prioritaria inmediata, se abrirá nuestro canal oficial de WhatsApp.`);
          
          const waText = `👋 *¡Hola SERPROMAQ! Acabo de enviar una consulta desde la web:*%0A%0A` +
            `👤 *Nombre:* ${encodeURIComponent(name)}%0A` +
            `📞 *Teléfono:* ${encodeURIComponent(phone)}%0A` +
            `🏢 *Empresa:* ${encodeURIComponent(company || 'Particular')}%0A` +
            `📧 *Correo:* ${encodeURIComponent(email)}%0A` +
            `🚜 *Servicio:* ${encodeURIComponent(service)}%0A` +
            `📝 *Mensaje:* ${encodeURIComponent(message || 'Solicito cotización')}`;

          window.open(`https://wa.me/573168275829?text=${waText}`, '_blank');

          contactForm.reset();
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          submitBtn.style.background = '';
        }, 300);
      });
    });
  }
}
